<template>
    <div class="row row-sezione">
        <div class="col">
            <inc-autocomplete
                @onAddressPick="onAddressPick"
                :defaultAddress="this.form.address"
                :defaultHouseNumber="this.form.house_number"
                :address-error="this.address_error"
                :number-error="this.number_error"
            >
                <div slot="button" class="input-group-append" v-if="this.form.address && this.form.house_number">
                    <button type="button" class="btn btn-primary" @click="this.continueWithFinalGeocoding">
                        <i class="far fa-arrow-alt-circle-right"></i>
                    </button>
                </div>
            </inc-autocomplete>
            <div class="invalid-feedback" v-if="this.address_error || this.number_error">
                <div v-if="this.address_error">
                    {{this.$t('error_cap')}}
                </div>
                <div v-if="this.number_error">
                    {{this.$t('error_numero')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import {geocode} from "../../../../api/mixed";
import IncAutocomplete from "../../../partials/IncAutocomplete";
import {buildAddressFromGeoResult} from "../../../../libraries/utils";

export default {
    name: "Lv1DeliveryCoordinate",
    components: {IncAutocomplete},
    props: ['address', 'consegneCitta'],
    data() {
        return {
            place: null,
            address_error: false,
            number_error: false,
            form: {
                address: this.address ? this.address.formatted_address : null,
                house_number: this.address ? this.address.numero_civico : null
            }
        }
    },
    computed: {
        ...mapState('localization', {
            language: state => state.language
        })
    },
    methods: {
        onAddressPick: function (place, address, number) {
            this.place = place;
            this.form.address = address;
            this.form.house_number = number;
        },
        continueWithFinalGeocoding: function () {
            this.number_error = false;
            let address = buildAddressFromGeoResult(this.place, this.form.house_number);
            if (!address) address = this.address?.formatted_address;

            geocode(this.language, {
                address,
            }).then((response) => {
                if (response.results.length) {
                    let geocodeResult = response.results[0];

                    let postal_code = geocodeResult.address_components.find(
                        (address_component) => {
                            return address_component.types.includes('postal_code');
                        },
                    );

                    let streetNumber = geocodeResult.address_components.find(
                        (address_component) => {
                            return address_component.types.includes('street_number');
                        },
                    );

                    if (postal_code && streetNumber) {
                        this.form.house_number = streetNumber.long_name;
                        this.form.address = geocodeResult.formatted_address;
                        this.place = geocodeResult;

                        this.$emit('onAddressPicked', this.place, this.form.address, this.form.house_number);
                    } else {
                        if (!postal_code) {
                            this.address_error = true;
                        }
                        if (!streetNumber) {
                            this.number_error = true;
                        }
                    }
                }
            }).catch((error) => {
                //Errore nel geocode
            });
        }
    }
}
</script>
